import { Editor, PureEditorContent } from "@tiptap/react";
import { useCallback, useMemo, useRef } from "react";
import { getMentionedUserIds } from "@src/features/contentDetail/utils/tiptap";

export type TipTapEditorRefUtils = {
  editorRef: React.RefObject<PureEditorContent | null>;
  editor: Editor | null | undefined;
  editorElement: Element | null | undefined;
  getMentionedUserIds: () => number[];
};

const useTipTapEditorRef = (): TipTapEditorRefUtils => {
  const editorRef = useRef<PureEditorContent>(null);
  const editor = editorRef?.current?.props?.editor;
  const editorElement = editorRef?.current?.editorContentRef?.current;
  const getMentionedUserIdsCallback = useCallback((): number[] => {
    if (!editor) {
      return [];
    }
    return getMentionedUserIds(editor);
  }, [editor]);
  return useMemo(
    () => ({
      editorRef,
      editor,
      editorElement,
      getMentionedUserIds: getMentionedUserIdsCallback,
    }),
    [editor, editorElement, getMentionedUserIdsCallback],
  );
};

export default useTipTapEditorRef;
